@if (!address) {
<div (click)="hide()">
  <form [formGroup]="postcodeLookupFormgroup">
    <div class="form-group mb-3">
      <div class="d-md-flex d-grid gap-3 gap-md-0 align-items-end mb-2">
        <div class="me-2 pc-fg" [ngClass]="isIndividual && !isHomePage ? 'w-75' : ''">
          <label id="postcode0" for="EnterYourPostcode_YourPostcode" class="labelTyp4 fs-17"
            [ngClass]="!postcodeLookupFormgroup.get('postcode').valid && postcodeLookupFormgroup.get('postcode').touched ? 'errorState' : ''">Your
            postcode</label>
          <mat-form-field floatLabel='never' class="w-100 resizeXS fname-form-field ctm-input no-error-display"
            appearance="fill">
            <input id="EnterYourPostcode_YourPostcode" matInput formControlName="postcode" type="text"
              (focus)="stateSet('focus')" (blur)="stateSet('blur')"
              class="cy-postcode sessioncamexclude sessioncamhidetext maskpii inputTyp2 text-uppercase fw500"
              aria-label="Enter your postcode" />
          </mat-form-field>
        </div>
        @if (isHomePage && arkoseLab) {
        <app-arkose #arkose [publicKey]="arkoseLab" mode="lightbox" (onCompleted)="postcodelookUp($event)"
          (onError)="onError($event)" (onFailed)="onError($event)" (onHide)="onArkoseCancelled()" class="mt-5"
          selector="arkose-ec">
        </app-arkose>
        }
        <button id="YourPostcode_FindAddress" class="btn btn-primary pc-btn text-nowrap"
          [ngClass]="isAddressLookUp ? 'animate' : ''" [disabled]="isAddressLookUp"
          (click)="!isAddressLookUp ? (isHomePage && arkoseLab ? findAddress() : postcodelookUp()) : ''">
          <span class="spinner"></span>
          <span class="text">Find address</span>
        </button>
      </div>
    </div>

    <!-- List of address -->
    @if (addressList.length > 0 && isVisible) {
    <div id="EnterYourPostcode_SelectYourAddress" class="address"
      [ngClass]="{'address-inline': isIndividual}">
      <div class="addressListing" [ngClass]="{'addressListing-inline': isIndividual}">
        <div class="addressTitle">Select your address</div>
        <ul class="p-0">
          @for (address of addressList; track address.addressId; let i = $index) {
          <li [id]="'SelectYourAddress_' + i" class="sessioncamexclude sessioncamhidetext maskpii" tabindex="0"
            (click)="selectedAddress(address)">
            {{address.Text}}
          </li>
          }
        </ul>
      </div>
    </div>
    }

    <!-- Error message -->
    @if (postcodeLookupFormgroup.get('postcode').invalid && postcodeLookupFormgroup.get('postcode').touched) {
    <div class="fs-17 errorState" id="errorOne" [innerHtml]="errorMessage"></div>
    }

    <!-- Terms and conditions -->
    <div class="fs-13 lh-1 mb-3">
      We share your information with third parties, which includes retrieving your current and previous energy
      information. By continuing you accept our <a class="elink"
        href="https://www.comparethemarket.com/information/terms-and-conditions/" target="_blank">terms and
        conditions</a>, which includes confirming you have the bill-payers permission to access the data. Please see
      our <a class="elink" href="https://www.comparethemarket.com/information/privacy-policy/" target="_blank">privacy
        policy</a> to understand how we will use your information to provide the service to you.
    </div>
  </form>
</div>
}